import { render, staticRenderFns } from "./editable-table.vue?vue&type=template&id=30ec3042"
import script from "./editable-table.vue?vue&type=script&lang=js"
export * from "./editable-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../voice-2025/node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports